import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=54794d6e&scoped=true&lang=pug"
import script from "./DeleteBtn.vue?vue&type=script&lang=js"
export * from "./DeleteBtn.vue?vue&type=script&lang=js"
import style0 from "./DeleteBtn.vue?vue&type=style&index=0&id=54794d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54794d6e",
  null
  
)

export default component.exports